// extracted by mini-css-extract-plugin
export default {"root":"Status_root__ocjwa","green":"Status_green__Pk38j","orange":"Status_orange__SyyVb","gray":"Status_gray__FVkeG","red":"Status_red__Xu7l4","text":"Status_text__p4pC4"};